export default __webpack_public_path__ + "static/media/like.2abb10b6.jpg";